import { resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, resolveDynamicComponent as _resolveDynamicComponent, openBlock as _openBlock, createBlock as _createBlock, KeepAlive as _KeepAlive, withCtx as _withCtx, createCommentVNode as _createCommentVNode, normalizeClass as _normalizeClass, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-50f528a6"),n=n(),_popScopeId(),n)
const _hoisted_1 = { key: 0 }
const _hoisted_2 = { class: "card" }
const _hoisted_3 = {
  key: 1,
  style: {"display":"flex","flex-direction":"column","justify-content":"center","align-items":"center"}
}
const _hoisted_4 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", null, "Registrazione completata con successo!", -1 /* HOISTED */))
const _hoisted_5 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", null, "A breve verrai indirizzato alla dashboard", -1 /* HOISTED */))
const _hoisted_6 = [
  _hoisted_4,
  _hoisted_5
]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_Toast = _resolveComponent("Toast")!
  const _component_Steps = _resolveComponent("Steps")!
  const _component_router_view = _resolveComponent("router-view")!
  const _component_Button = _resolveComponent("Button")!
  const _component_GvSpinner = _resolveComponent("GvSpinner")!

  return (_openBlock(), _createBlock(_component_GvSpinner, { "is-loading": $setup.isLoading }, {
    default: _withCtx(() => [
      _createVNode(_component_Toast, { position: "top-center" }),
      (!$setup.signupCompleted)
        ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
            _createElementVNode("div", _hoisted_2, [
              _createVNode(_component_Steps, {
                model: $setup.items,
                readonly: true,
                id: "signup-step"
              }, null, 8 /* PROPS */, ["model"])
            ]),
            _createVNode(_component_router_view, { onCanGoForward: $setup.setNextButtonEnableStatus }, {
              default: _withCtx(({ Component }) => [
                (_openBlock(), _createBlock(_KeepAlive, null, [
                  (_openBlock(), _createBlock(_resolveDynamicComponent(Component)))
                ], 1024 /* DYNAMIC_SLOTS */))
              ]),
              _: 1 /* STABLE */
            }, 8 /* PROPS */, ["onCanGoForward"]),
            _createElementVNode("div", {
              class: _normalizeClass([
					$setup.currentStep > 0 ? 'spacedBetweenButton' : 'singleNavigationButton',
				])
            }, [
              ($setup.currentStep > 0)
                ? (_openBlock(), _createBlock(_component_Button, {
                    key: 0,
                    class: "gv-button",
                    onClick: $setup.prevPage,
                    label: "Precedente"
                  }, null, 8 /* PROPS */, ["onClick"]))
                : _createCommentVNode("v-if", true),
              _createVNode(_component_Button, {
                class: "gv-button",
                disabled: $setup.disabledButton,
                onClick: $setup.forwardButton.action,
                label: $setup.forwardButton.text
              }, null, 8 /* PROPS */, ["disabled", "onClick", "label"])
            ], 2 /* CLASS */)
          ]))
        : ($setup.signupCompleted)
          ? (_openBlock(), _createElementBlock("div", _hoisted_3, _hoisted_6))
          : _createCommentVNode("v-if", true)
    ]),
    _: 1 /* STABLE */
  }, 8 /* PROPS */, ["is-loading"]))
}